import { Button, Input, Space, theme } from 'antd'
import { useRef, useState } from 'react'

import { SearchOutlined } from '@ant-design/icons'
import { useCallback } from 'react'
import { useTranslations } from 'hooks'

const useGetTableSearchProps = ({ placeholder } = {}) => {
  const { t } = useTranslations()
  const { colorPrimary } = theme.useToken().token

  // eslint-disable-next-line no-unused-vars
  const [searchText, setSearchText] = useState('')
  // eslint-disable-next-line no-unused-vars
  const [searchedColumn, setSearchedColumn] = useState('')

  const searchInput = useRef(null)
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm({ confirm: true })
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }
  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }
  const getColumnSearchProps = useCallback(
    (dataIndex, searchFields) => ({
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        close
      }) => (
        <div
          style={{
            padding: 8
          }}
          onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={`Search by ${dataIndex}` || `${t('Search items')}...`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
              marginBottom: 8,
              display: 'block'
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90
              }}>
              {t('Search')}
            </Button>
            <Button
              onClick={() => clearFilters && handleReset(clearFilters)}
              size="small"
              style={{
                width: 90
              }}>
              {t('Reset')}
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                close()
              }}>
              {t('Close')}
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: filtered ? colorPrimary : undefined
          }}
        />
      ),
      onFilter: (value, record) => {
        return searchFields?.some((field) =>
          record[field]
            ? record[field]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            : ''
        )
      },
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100)
        }
      },
      render: (text) => text
    }),
    [colorPrimary, t]
  )

  return getColumnSearchProps
}

export default useGetTableSearchProps
